import { render, staticRenderFns } from "./more-vert.vue?vue&type=template&id=5b02545e&"
import script from "./more-vert.vue?vue&type=script&lang=js&"
export * from "./more-vert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports